const EmptyState = <template>
  <div class="c-list-empty-state" ...attributes>
    {{yield}}
  </div>
</template>;

export default EmptyState;
